import type { ReactNode } from "react";
import { Fragment } from "react";

interface Props<TData> {
  data: TData[];
  hidden?: boolean;
  highlight?: ReactNode;
  getItemType?: (item: TData) => string;
  renderReject?: (item: TData) => ReactNode;
  renderApprove?: (item: TData) => ReactNode;
}

function ApprovalHistoryContent<TData extends { type?: string; value?: any; date?: any }>(
  props: Props<TData>
) {
  const { data, hidden, highlight, getItemType, renderApprove, renderReject } = props;

  if (hidden) {
    return null;
  }

  return (
    <Fragment>
      {data.map((item, index) => {
        const isReject = (getItemType?.(item) ?? item.type) === "reject";

        return (
          <div className="py-2 pl-3" key={index}>
            {highlight && <span className="font-weight-bold">{highlight}</span>}{" "}
            {isReject
              ? renderReject?.(item) ?? (
                  <>
                    đã từ chối với lý do: {item.value} ({item.date})
                  </>
                )
              : renderApprove?.(item) ?? (
                  <>
                    đã phê duyệt, lưu ý: {item.value} ({item.date})
                  </>
                )}
          </div>
        );
      })}
    </Fragment>
  );
}

export default ApprovalHistoryContent;
